import { ReactNode } from "react"

interface LoginScreenProps {
  onSignInAnonymous: () => void
  onSignInWithGoogle: () => void
  onSignInWithPhone: () => void
}

export function LoginScreen({ onSignInAnonymous, onSignInWithGoogle, onSignInWithPhone }: LoginScreenProps): ReactNode {
  return (
    <div className="d-flex flex-column gap-3 w-100" style={{ maxWidth: 400 }}>
      <button className="btn btn-primary form-control" onClick={onSignInAnonymous}>
        匿名ログイン
      </button>
      <button className="btn btn-outline-dark form-control" onClick={onSignInWithGoogle}>
        Google でログイン
      </button>
      <button className="btn btn-outline-success form-control" onClick={onSignInWithPhone}>
        電話番号でログイン
      </button>
      <div id="recaptcha-container" />
    </div>
  )
}
